export { ConnectorType, ConnectorPlatform } from '@logto/connector-kit';
